var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1108 0H2.2562C1.22892 0 0.390559 0.792369 0.366943 1.77809C0.366943 1.79326 0.366943 1.80842 0.366943 1.81979V15.1649C0.366943 15.1801 0.366943 15.1953 0.366943 15.2104C0.390559 16.1962 1.22892 16.9847 2.2562 16.9847H16.1108C17.1499 16.9847 17.9961 16.1734 18 15.1763V1.81221C17.9961 0.811325 17.1499 0 16.1108 0ZM6.94787 5.42905L12.5645 8.50754L6.94787 11.586V5.42905Z",
    fill: "#6A3926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.366943,
    width: 17.6331,
    height: 16.9847,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMusic);
export default __webpack_public_path__ + "static/media/youtube_music.2758c6b083605959ba195748aaf0cc48.svg";
export { ForwardRef as ReactComponent };